// Validazione dei valori di stile provenienti dalla config del banner (dato admin/seedato).
// Mai fare echo del valore grezzo in uno stile inline: si accettano solo formati noti, altrimenti
// si scarta (fallback al variant di tema). Difesa contro CSS-injection da contenuto non fidato.

const HEX_COLOR = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
const RGB_COLOR = /^rgba?\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*(?:,\s*(?:0|1|0?\.\d+)\s*)?\)$/;

/**
 * Restituisce il colore solo se e' un esadecimale (#rgb/#rrggbb) o un rgb()/rgba() numerico,
 * altrimenti null. Il chiamante usa null per ripiegare sul variant di tema.
 */
export function safeColor(value) {
  if (typeof value !== "string") return null;
  const candidate = value.trim();
  if (HEX_COLOR.test(candidate) || RGB_COLOR.test(candidate)) {
    return candidate;
  }
  return null;
}

/**
 * Restituisce l'URL immagine solo se e' un https:// valido, altrimenti null. Esclude
 * schemi non sicuri (javascript:, data:, http:) usati per injection o leak di privacy.
 */
export function safeImageUrl(value) {
  if (typeof value !== "string") return null;
  const candidate = value.trim();
  // Scarta i caratteri che romperebbero il contesto url('...') (apici, parentesi, spazi):
  // difesa in profondita' contro CSS-injection, oltre al solo controllo di protocollo.
  if (/["'()\s]/.test(candidate)) {
    return null;
  }
  let parsed = null;
  try {
    parsed = new URL(candidate);
  } catch (e) {
    // Valore non interpretabile come URL: scartato.
    return null;
  }
  if (parsed.protocol === "https:") {
    return candidate;
  }
  // In sviluppo l'API gira su http://localhost|127.0.0.1: si accetta http SOLO per il loopback, cosi'
  // le immagini del banner sono visibili in locale senza indebolire la regola in produzione (per
  // qualsiasi host reale resta ammesso solo https).
  if (
    parsed.protocol === "http:" &&
    (parsed.hostname === "localhost" || parsed.hostname === "127.0.0.1")
  ) {
    return candidate;
  }
  return null;
}
